import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import { withApollo } from '@apollo/react-hoc';
import Cookies from 'js-cookie';
import { Button, Checkbox, Divider, Form, Input } from 'antd';
import queryString from 'query-string';
import { gql } from '@apollo/client';
import numeral from 'numeral';
import { CardElement } from '@stripe/react-stripe-js';
import { withRouter } from 'react-router-dom';
import logger from '$lib/logger';
import storage from '$lib/storage';
import { track, trackSignUp } from '$lib/tracking';
import {
  trackAffiliateSale,
  trackFacebookSale,
  trackGoogleSale,
  trackRedditSale,
} from './tracking';
import PromoCodeForm from './PromoCodeForm';
import styles from './styles.scss';

const reload = () => window.location.reload();

const PRODUCT_UPGRADE = gql`
  mutation ProductUpgrade($input: ProductUpgradeInput!) {
    productUpgrade(input: $input) {
      chargeUuid
      createdUser {
        uuid
        email
        accessToken
      }
    }
  }
`;

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      fontWeight: 400,
      iconColor: '#424770',
      color: '#424770',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#38bed9',
      },
    },
    invalid: {
      color: '#9e2146',
      iconColor: '#9e2146',
    },
  },
};

const validateCaptcha = () => {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute('6LeS-hoaAAAAAAbid0nALboMvc30TYxao1VDWMd1', { action: 'purchase' })
        .then((token) => {
          resolve(token);
        }, reject);
    });
  });
};

const SOURCE_PROMOS = ['amizoa', 'benwhite', 'crush', 'crushGRE', 'edg3', 'tpi'];

const getFormattedPrice = ({ price }) => {
  if (price === 0) {
    return (
      <span>
        <span>A smile&nbsp;</span>
        <i className="fas fa-smile" />
      </span>
    );
  }

  if (price === Math.floor(price)) {
    return numeral(price).format('$0');
  }

  return numeral(price).format('$0.00');
};

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);

    const { currentUser, location, product } = props;
    const { slug: productSlug } = product;

    const { hash } = location;
    const { p: hashPromo } = queryString.parse(hash);
    const utmSource = _.get(currentUser, 'source', Cookies.get('utmSource'));
    let promo = hashPromo || _.get(currentUser, 'promo', Cookies.get('promo'));

    if (productSlug === 'amc-8' && _.isEmpty(promo)) {
      promo = 'AMC8_WIP';
    }

    if (productSlug === 'amc-10' && _.isEmpty(promo)) {
      promo = 'AMC10_WIP';
    }

    if (productSlug === 'amc-12' && _.isEmpty(promo)) {
      promo = 'AMC12_WIP';
    }

    if (productSlug === 'finra-series-6' && _.isEmpty(promo)) { // TODO(finra-series-6)
      promo = 'S6_EARLY_ACCESS';
    }

    const isSourcePromo = (() => {
      for (let i = 0; i < SOURCE_PROMOS.length; i += 1) {
        const sourcePromo = SOURCE_PROMOS[i];
        const regex = new RegExp(sourcePromo, 'i');
        if (regex.test(utmSource)) {
          return true;
        }
      }

      return false;
    })();

    if (_.isEmpty(promo) && (/^r-\w+$/i.test(utmSource) || isSourcePromo)) {
      promo = utmSource;
    }

    this.state = {
      acceptedTerms: false,
      cardComplete: false,
      cardReady: false,
      code: promo,
      utmSource,
      paymentProcessing: false,
      price: props.product.price,
      promoCodeOpen: !_.isEmpty(promo),
      promoCodeProcessing: false,
    };
  }

  handleCardChange = (change) => {
    logger.log('[change]', change);

    this.setState({
      cardComplete: change.complete,
    });
  };

  handleCardReady = () => {
    this.setState({
      cardReady: true,
    });
  };

  handleTermsChange = (e) => {
    const acceptedTerms = e.target.checked;
    this.setState({
      acceptedTerms,
    });
  };

  onFinish = async (values) => {
    this.setState({
      paymentProcessing: true,
    });

    const {
      currentUser,
      client,
      elements,
      stripe,
      product,
      organizationUuid,
      showEnrollmentForm,
    } = this.props;
    const { code, price, utmSource } = this.state;

    const { email, receiptEmail, password } = values;

    let stripeToken;

    // Use elements.getElement to get a reference to the mounted Element.
    const cardElement = elements.getElement(CardElement);

    if (price) {
      // Pass the Element directly to other Stripe.js methods:
      // e.g. createToken - https://stripe.com/docs/js/tokens_sources/create_token?type=cardElement
      const stripeTokenFull = await stripe.createToken(cardElement);

      logger.log(stripeTokenFull);
      stripeToken = stripeTokenFull.token ? stripeTokenFull.token.id : null;
      logger.log(stripeToken);

      if (!stripeToken) {
        this.setState({
          cardError: stripeTokenFull.error.message,
          paymentProcessing: false,
        });
        return;
      }
    }

    const input = {
      code,
      utmSource,
      price,
      productUuid: product.uuid,
      organizationUuid,
      stripeToken,
      receiptEmail,
    };

    if (organizationUuid) {
      input.user = {
        email: email.trim(),
        source: 'enrollment',
      };
    } else if (!currentUser) {
      input.user = {
        email: email.trim(),
        password,
        source: utmSource,
      };
    }

    const recaptchaToken = await validateCaptcha();
    input.recaptchaToken = recaptchaToken;

    try {
      const { data } = await client.mutate({
        mutation: PRODUCT_UPGRADE,
        variables: {
          input,
        },
        // refetchQueries={[{ query: CURRENT_USER }, { query: PRODUCT, variables: { input: { slug } } }]}
      });

      logger.log(data);
      const { productUpgrade } = data;
      const { createdUser, chargeUuid } = productUpgrade;

      this.setState({
        chargeUuid,
        createdUser,
      });

      const { slug } = product;
      const value = price;

      trackFacebookSale({ value });
      trackGoogleSale({ value, code, chargeUuid, slug });
      trackRedditSale();
      track('Product | Purchased', { productSlug: slug });

      if (!showEnrollmentForm) {
        trackAffiliateSale({ price, chargeUuid, slug });
      }
    } catch (processingError) {
      logger.log(processingError);
      this.setState({
        cardError: processingError.graphQLErrors[0].message,
      });
    }

    this.setState({
      paymentProcessing: false,
    });
  };

  showPromoCode = () => {
    this.setState({
      promoCodeOpen: true,
    });
  };

  renderFormInner() {
    const { client, product, currentUser, organizationUuid, showEnrollmentForm } =
      this.props;
    const { price: originalPrice } = product;

    const {
      cardError,
      code,
      paymentProcessing,
      price: priceRaw,
      promoCodeOpen,
      promoCodeProcessing,
      chargeUuid,
      createdUser,
    } = this.state;

    const isFree = priceRaw === 0;

    if (createdUser && !showEnrollmentForm) {
      const { uuid, email, accessToken } = createdUser;
      storage.setAuth({ email, accessToken });
      trackSignUp({ userUuid: uuid, sourcePage: 'purchase' });
    }

    if (chargeUuid) {
      if (showEnrollmentForm) {
        return (
          <div className={styles.confirmation}>
            <div className={styles.confirmationHeader}>Success, thank you!</div>
            <div className={styles.confirmationText}>
              An email has been sent with access information.
            </div>
            <div className={styles.confirmationRef}>
              <div>
                Charge ref:{' '}
                <span data-aaa="chargeUuid" data-charge-uuid={chargeUuid}>
                  {chargeUuid}
                </span>
              </div>
              {createdUser && (
                <div>
                  User ref:{' '}
                  <span data-aaa="userUuid" data-user-uuid={createdUser.uuid}>
                    {createdUser.uuid}
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      }

      return (
        <div className={styles.confirmation}>
          <div className={styles.confirmationHeader}>Success, thank you!</div>
          <div className={styles.confirmationText}>Check your email for a receipt.</div>
          <Button data-aaa="purchaseReloadButton" type="primary" onClick={reload}>
            Let&apos;s get down to business
          </Button>
        </div>
      );
    }

    return (
      <div>
        <div data-aaa="priceContainer" className={styles.price}>
          {code ? (
            <span>
              <span className={styles.priceTagOriginal}>
                {getFormattedPrice({ price: originalPrice })}
              </span>
              <span className={styles.priceTagDiscounted}>
                {getFormattedPrice({ price: priceRaw })}
              </span>
            </span>
          ) : (
            <span className={styles.priceTag}>
              {getFormattedPrice({ price: priceRaw })}
            </span>
          )}
          {!promoCodeOpen && (
            <a
              data-aaa="showPromoCode"
              className={styles.showPromoCode}
              onClick={this.showPromoCode}
            >
              Have a promo code?
            </a>
          )}
        </div>

        <Divider className={styles.divider} />

        {promoCodeOpen && (
          <div>
            <PromoCodeForm
              client={client}
              code={code}
              product={product}
              organizationUuid={organizationUuid}
              setParentState={(d) => this.setState(d)}
            />
            <Divider className={styles.divider} />
          </div>
        )}

        {cardError && <div className={styles.error}>{cardError}</div>}

        <Form onFinish={this.onFinish}>
          {!isFree && (
            <div className={styles.cardElementContainer}>
              <div className={styles.sectionHeader}>Payment info</div>
              <CardElement
                className={styles.cardElement}
                onChange={this.handleCardChange}
                onReady={this.handleCardReady}
                disabled={paymentProcessing || promoCodeProcessing}
                options={CARD_ELEMENT_OPTIONS}
              />
              <div className={styles.securePayments}>
                <i className="fad fa-lock" />
                Secure payments by <span className={styles.stripe}>stripe</span>
              </div>
            </div>
          )}
          <Divider className={styles.divider} />
          {showEnrollmentForm ? (
            <>
              <div className={styles.sectionHeader}>Enrollment info</div>
              <Form.Item
                name="email"
                rules={[
                  {
                    type: 'email',
                    required: true,
                    message: 'Email of user accessing the course',
                  },
                ]}
              >
                <Input
                  data-aaa="signUpEmail"
                  autoComplete="username"
                  prefix={<i className="fal fa-user" />}
                  placeholder="Email (to grant access)"
                  disabled={paymentProcessing}
                />
              </Form.Item>
              <Form.Item
                name="receiptEmail"
                rules={[{ type: 'email', message: 'Email for receipt' }]}
              >
                <Input
                  data-aaa="receiptEmail"
                  autoComplete="username"
                  prefix={<i className="fal fa-receipt" />}
                  placeholder="Receipt email (optional)"
                  disabled={paymentProcessing}
                />
              </Form.Item>
            </>
          ) : (
            !currentUser && (
              <>
                <div className={styles.sectionHeader}>New account info</div>
                <Form.Item
                  name="email"
                  rules={[
                    { type: 'email', required: true, message: 'Please input your email' },
                  ]}
                >
                  <Input
                    data-aaa="signUpEmail"
                    autoComplete="username"
                    prefix={<i className="fal fa-user" />}
                    placeholder="Email"
                    disabled={paymentProcessing}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Please input a password' }]}
                >
                  <Input
                    data-aaa="signUpPassword"
                    autoComplete="new-password"
                    prefix={<i className="fal fa-lock" />}
                    type="password"
                    placeholder="Password"
                    disabled={paymentProcessing}
                  />
                </Form.Item>
              </>
            )
          )}
          <Form.Item
            className={styles.terms}
            name="terms"
            valuePropName="checked"
            rules={[
              {
                required: true,
                transform: (value) => value || undefined,
                type: 'boolean',
                message: 'You must agree to the T&C',
              },
            ]}
          >
            <Checkbox
              disabled={paymentProcessing}
              data-aaa="upgradeTerms"
              onChange={this.handleTermsChange}
            >
              I agree to the{' '}
              <a
                href="https://www.iubenda.com/terms-and-conditions/18707085"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
            </Checkbox>
          </Form.Item>
          <div className={styles.payContainer}>
            <div className={styles.recaptchaText}>
              This site is protected by reCAPTCHA and the Google{' '}
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
              <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </div>
            <Button
              data-aaa="upgradeSubmit"
              block
              type="primary"
              loading={paymentProcessing}
              htmlType="submit"
            >
              {isFree ? 'Activate free access' : 'Pay with card'}
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  render() {
    const { className, product } = this.props;

    return (
      <div className={classnames(className, styles.stripeForm)}>
        <fieldset>
          <legend>Buy {product.shortName}</legend>
          {this.renderFormInner()}
        </fieldset>
      </div>
    );
  }
}

export default withRouter(withApollo(CheckoutForm));
